import React from 'react'
import { AUTO_TAG_PARTS, AutoTagSettings } from '../lib/autoTags'

interface AutoTagsSettingsProps {
  value: AutoTagSettings
  onChange: (next: AutoTagSettings) => void
}

/**
 * TAGS tab: automatic brand / model / gender / category tags (W5). Saved with the rest of
 * the configuration as `config_object.auto_tags`.
 */
const AutoTagsSettings: React.FC<AutoTagsSettingsProps> = ({ value, onChange }) => (
  <div className="glass-card rounded-xl p-6">
    <div className="flex items-start justify-between gap-4 mb-4">
      <div>
        <h3 className="text-base font-bold text-orange-400">AUTOMATIC TAGS</h3>
        <p className="text-sm text-white/50 mt-1">
          FlowStock tags every product with its brand, model, gender and category, read from the
          product name and our shared catalogue. Use them to build collections ("Samba",
          "Tasman", "Air Max 90") without writing rules. Tags are only added, never removed.
          Your supplier catalogues show each product's tags before it is imported.
        </p>
      </div>
      <label className="flex items-center gap-2 cursor-pointer shrink-0">
        <input
          type="checkbox"
          className="w-4 h-4 accent-orange-500"
          checked={value.enabled}
          onChange={(e) => onChange({ ...value, enabled: e.target.checked })}
        />
        <span className="text-sm text-white">{value.enabled ? 'On' : 'Off'}</span>
      </label>
    </div>
    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-3 ${value.enabled ? '' : 'opacity-50 pointer-events-none'}`}>
      {AUTO_TAG_PARTS.map((part) => (
        <label key={part.key} className="flex items-start gap-2 cursor-pointer">
          <input
            type="checkbox"
            className="w-4 h-4 mt-0.5 accent-orange-500"
            checked={value[part.key]}
            disabled={!value.enabled}
            onChange={(e) => onChange({ ...value, [part.key]: e.target.checked })}
          />
          <span>
            <span className="block text-sm text-white">{part.label}</span>
            <span className="block text-xs text-white/40">{part.example}</span>
          </span>
        </label>
      ))}
    </div>
    <p className="text-xs text-white/40 mt-4">
      A tag that one of your product lines uses is left to that line, so its excludes keep working.
    </p>
  </div>
)

export default AutoTagsSettings
